export default __webpack_public_path__ + "static/media/sphero-fast-class-icon.3fd52efa.svg";